import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "../styles/Navbar.css";
import logo from "../IMG/logo.png";
export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/"); // leva para a Home
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand" onClick={() => navigate("/")}>
        <span className="navbar-logo"><img src={logo} alt="" /> SGA</span>
      </div>

      <div className="navbar-links">
        {user ? (
          <>
            <Link to="/dashboard" className="nav-item">Dashboard</Link>
            <span className="nav-user">
              Olá, <strong>{user}</strong>
            </span>
            <button onClick={handleLogout} className="btn nav-logout">
              Sair
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-item">Entrar</Link>
            <Link to="/register" className="btn nav-register">
              Criar Conta
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
